/** @format */

/***
 * TODO: refactor into IIFE, rather messy as is
 *
 * this page kinda got out of hand, it handles the first tab (Applicants)
 * of the Subsidy Application form and also handles the tabbing logic of
 * loading js for the other tabs. It should be refactored down to IIFE
 * to provide cleaner code. My appologies for the mess. -AG
 *
 * */

var vm,
    ajaxCount = 0,
    dataIsLoaded = false;

function loadApplicant(data) {
    // application id
    vm.$data.id = data.Id;
    // applicant id
    vm.$data.applicant.id = data.ClientId;
    // first and last name
    vm.$data.applicant.firstName = data.Client.FirstName;
    vm.$data.applicant.lastName = data.Client.LastName;

    if (!!vm.$data.applicant.firstName && !!vm.$data.applicant.lastName) {
        vm.$data.control.nameIsProvided = true;
    }

    // adddress
    if (!data.ApplicantAddress) {
        vm.$data.control.addressIsProvided = false;
    } else {
        var a = data.ApplicantAddress;
        loadAddress(a);
    }

    // email
    vm.$data.applicant.email = data.Client.Email;

    // phone numbers
    if (data.PhoneNumbers && data.PhoneNumbers.length > 0) {
        for (var i = 0; i < data.PhoneNumbers.length; i++) {
            loadPhoneNumber(data.PhoneNumbers[i]);
        }
        vm.$data.control.phoneIsProvided = true;
    }

    // statuses
    if (data.Applicant && !not(data.Applicant.CitizenStatusCode)) {
        vm.$data.applicant.citizenStatus = data.Applicant.CitizenStatusCode;
    }
    if (data.Applicant && !not(data.Applicant.MaritalStatusCode)) {
        vm.$data.applicant.maritalStatus = data.Applicant.MaritalStatusCode;
    }
    if (data.Applicant && !not(data.Applicant.NeedForChildcareCode)) {
        vm.$data.applicant.childCareNeed = data.Applicant.NeedForChildcareCode;
    }

    // other
    vm.$data.applicant.childCareOther = data.Applicant.NeedForChildcareOther;
}

// pass reference data to vuejs
function loadLists(data) {
    vm.$data.lists.needTypes = data.ChildCareNeedTypes;
    vm.$data.lists.citizenTypes = data.CitizenTypes;
    vm.$data.lists.maritalTypes = data.MaritalTypes;
}

// pass phone number info to vuejs
function loadPhoneNumber(n) {
    // 1 = home, 3 = cell
    if (n.PhoneNumberTypeCd === 1) {
        vm.$data.applicant.homeNumber = n.PhoneNumber;
    } else if (n.PhoneNumberTypeCd === 3) {
        vm.$data.applicant.cellNumber = n.PhoneNumber;
    }
}

// pass address info to vuejs
function loadAddress(a) {
    vm.$data.control.addressIsProvided = true;

    vm.$data.applicant.addressId = a.Id;
    var unit = "";
    if (a.UnitNumber) {
        unit = a.UnitNumber + "-";
    }
    vm.$data.applicant.address =
        unit +
        a.CivicNumber +
        " " +
        a.StreetName +
        ", " +
        a.Municipality +
        " " +
        a.Province +
        " " +
        a.PostalCode;
}

function loadCoApplicant(data) {
    if (data.CoApplicant) {
        vm.$data.coapp.firstName = data.CoApplicant.FirstName;
        vm.$data.coapp.lastName = data.CoApplicant.LastName;
        vm.$data.coapp.cellNumber = data.CoApplicant.CellNumber;
        vm.$data.coapp.otherNumber = data.CoApplicant.PhoneNumber;
        vm.$data.coapp.id = data.CoApplicant.Id;
        vm.$data.coapp.email = data.CoApplicant.Email;
        vm.$data.coapp.childCareNeed = data.CoApplicant.ChildCareNeedTypeCd;
        vm.$data.coapp.childCareOther = data.CoApplicant.ChildCareNeedOther;
        vm.$data.coapp.citizenStatus = data.CoApplicant.CitizenTypeCd;
        if (!!vm.$data.coapp.firstName && !!vm.$data.coapp.lastName) {
            vm.$data.control.co_nameIsProvided = true;
        }
        if (!!vm.$data.coapp.cellNumber || !!vm.$data.coapp.otherNumber) {
            vm.$data.control.co_phoneIsProvided = true;
        }
    }
}

// enable jQuery validation for dynamically added html
function enableValidation() {
    $(".subsidy-app *[data-val='true']").each(function() {
        $.validator.unobtrusive.parseElement($(this)[0]);
    });
}

// load our modal iframe
function loadAddressModal() {
    var id = vm.$data.applicant.addressId;
    var url =
        window.app.hrefPrefix() +
        "/" +
        window.app.currentLanguage() +
        "/profile/address/" +
        id +
        "/?modal=true";
    window.debug(url);
    window.app.loadFrame({
        href: url,
        title: "Edit Address",
        height: 650,
        closeOnly: true,
        onOk: function(data) {
            if (!data) return;
            window.debug("save called");
            var a = JSON.parse(data);
            window.debug(a);
            loadAddress(a);
            app.closeFrame();
        }
    });
}

// load application data
function getData() {
    var url =
        window.app.hrefPrefix() +
        "/" +
        window.app.currentLanguage() +
        "/subsidy/application/GetExistingApp/" +
        window.appId;
    $.post(url, { __RequestVerificationToken: window.requestToken }, function(data) {
        window.debug(data);

        loadApplicant(data);
        loadCoApplicant(data);
        loadLists(data);
        enableValidation();
        $(".loading").hide();
        $(".worko-tabs").show();
    });
}

function saveData(id, key, data, callback) {
    // don't save on initial load
    if (!dataIsLoaded) {
        return;
    }

    // save application data
    var url =
        window.app.hrefPrefix() +
        "/" +
        window.app.currentLanguage() +
        "/subsidy/application/SaveAppData/" +
        id;

    // increment ajax count
    ajaxCount++;

    // TODO: replace with jQuery.ajax
    $.post(
        url,
        {
            appId: window.appId,
            key: key,
            data: data,
            __RequestVerificationToken: window.requestToken
        },
        function(data) {
            window.debug(data);
            ajaxCount--;

            if (ajaxCount <= 0) {
                ajaxCount = 0; // should never go lower, but just in case of an ajax glitch
            }

            if (callback) callback();
        }
    );
}

function validateAllFields() {
    if (!vm.$data.applicant.firstName) {
        // make dirty if not provided
        vm.$v.applicant.firstName.$touch();
    }
    if (!vm.$data.applicant.lastName) {
        // make dirty if not provided
        vm.$v.applicant.firstName.$touch();
    }

    if (not(vm.$data.applicant.citizenStatus)) {
        // make dirty if not provided
        vm.$v.applicant.citizenStatus.$touch();
    }
    if (not(vm.$data.applicant.maritalStatus)) {
        // make dirty if not provided
        vm.$v.applicant.maritalStatus.$touch();
    }
    if (not(vm.$data.applicant.childCareNeed)) {
        // make dirty if not provided
        vm.$v.applicant.childCareNeed.$touch();
    }
    if (!vm.$data.applicant.address) {
        // make dirty if not provided
        vm.$v.applicant.address.$touch();
    }

    if (!vm.$data.applicant.homeNumber && !vm.$data.applicant.cellNumber) {
        // make dirty if not provided
        vm.$v.applicant.homeNumber.$touch();
        vm.$v.applicant.cellNumber.$touch();
    } else {
        if (
            // if homeNumber is provided but not a valid number, make dirty
            !!vm.$data.applicant.homeNumber &&
            !app.validPhoneNumber(vm.$data.applicant.homeNumber)
        ) {
            vm.$v.applicant.homeNumber.$touch();
        } else if (
            // if cellNumber is provided but not a valid number, make dirty
            !!vm.$data.applicant.cellNumber &&
            !app.validPhoneNumber(vm.$data.applicant.cellNumber)
        ) {
            vm.$v.applicant.cellNumber.$touch();
        }
    }

    if (
        !not(vm.$data.applicant.childCareNeed) &&
        vm.$data.applicant.childCareNeed === 2 &&
        !vm.$data.applicant.childCareOther
    ) {
        // make dirty if not provided
        vm.$v.applicant.childCareOther.$touch();
    }

    if (!vm.$data.coapp.firstName) {
        // make dirty if not provided
        vm.$v.coapp.firstName.$touch();
    }
    if (!vm.$data.coapp.lastName) {
        // make dirty if not provided
        vm.$v.coapp.firstName.$touch();
    }
    if (not(vm.$data.coapp.citizenStatus)) {
        // make dirty if not provided
        vm.$v.coapp.citizenStatus.$touch();
    }
    if (not(vm.$data.coapp.childCareNeed)) {
        // make dirty if not provided
        vm.$v.coapp.childCareNeed.$touch();
    }

    if (!vm.$data.coapp.otherNumber && !vm.$data.coapp.cellNumber) {
        // make dirty if not provided
        vm.$v.coapp.otherNumber.$touch();
        vm.$v.coapp.cellNumber.$touch();
    } else {
        if (
            // if homeNumber is provided but not a valid number, make dirty
            !!vm.$data.coapp.otherNumber &&
            !app.validPhoneNumber(vm.$data.coapp.otherNumber)
        ) {
            vm.$v.coapp.homeNumber.$touch();
        } else if (
            // if cellNumber is provided but not a valid number, make dirty
            !!vm.$data.coapp.cellNumber &&
            !app.validPhoneNumber(vm.$data.coapp.cellNumber)
        ) {
            vm.$v.coapp.cellNumber.$touch();
        }
    }

    if (
        !not(vm.$data.coapp.childCareNeed) &&
        vm.$data.coapp.childCareNeed === 2 &&
        !vm.$data.coapp.childCareOther
    ) {
        // make dirty if not provided
        vm.$v.coapp.childCareOther.$touch();
    }

    if (!vm.$data.coapp.email || !app.validEmail(vm.$data.coapp.email)) {
        // make dirty if not provided
        vm.$v.coapp.email.$touch();
    }
}

$(function() {
    if ($(".subsidy-app").length > 0) {
        // page data

        // pass data to applicant vuejs template

        /* Vuelidate Validators */
        var required = window.validators.required,
            minLength = window.validators.minLength,
            email = window.validators.email,
            requiredUnless = window.validators.requiredUnless,
            requiredIf = window.validators.requiredIf;

        var otherNeedValidator = function(value) {
            return vm.$data.applicant.childCareNeed === 2 && !!value;
        };

        /* End Vuelidate Validators */

        // load up vuejs for dynamic html
        Vue.use(window.vuelidate.default);
        vm = new Vue({
            el: ".subsidy-app",
            data: {
                id: 0,
                applicant: {
                    id: -1,
                    firstName: "",
                    lastName: "",
                    maritalStatus: "",
                    citizenStatus: "",
                    address: "",
                    addressId: 0,
                    homeNumber: "",
                    cellNumber: "",
                    email: "",
                    childCareNeed: "",
                    childCareOther: ""
                },
                coapp: {
                    id: -1,
                    firstName: "",
                    lastName: "",
                    citizenStatus: "",
                    cellNumber: "",
                    otherNumber: "",
                    email: "",
                    childCareNeed: "",
                    childCareOther: ""
                },
                lists: {
                    needTypes: [],
                    citizenTypes: [],
                    maritalTypes: []
                },
                control: {
                    // this holds our html control variables
                    nameIsProvided: false,
                    addressIsProvided: false,
                    addressIsError: false,
                    phoneIsProvided: false,
                    phoneIsError: false,
                    maritalIsError: false,
                    needIsError: false,
                    citizenIsError: false,
                    coappIsNeeded: false,
                    co_nameIsProvided: false,
                    co_phoneIsProvided: false
                }
            },
            computed: {
                "control.nameIsError": function() {
                    return !this.applicant.firstName || !this.applicant.lastName;
                },
                "control.co_nameIsError": function() {
                    return !this.coapp.firstName || !this.coapp.lastName;
                },
                applicantHomePhoneProvided: function() {
                    return !!this.applicant.homeNumber;
                },
                applicantCellPhoneProvided: function() {
                    return !!this.applicant.cellNumber;
                },
                coappRequired: function() {
                    return (
                        parseInt(this.applicant.maritalStatus) === 1 ||
                        parseInt(this.applicant.maritalStatus) === 2
                    );
                },
                coappOtherRequired: function() {
                    return this.coappRequired && parseInt(this.coapp.childCareNeed) === 2;
                },
                coappOtherPhoneProvided: function() {
                    return !!this.coapp.otherNumber;
                },
                coappCellPhoneProvided: function() {
                    return !!this.coapp.cellNumber;
                }
            },
            validations: {
                applicant: {
                    firstName: {
                        required
                    },
                    lastName: {
                        required
                    },
                    homeNumber: {
                        required: requiredUnless("applicantCellPhoneProvided")
                    },
                    cellNumber: {
                        required: requiredUnless("applicantHomePhoneProvided")
                    },
                    maritalStatus: {
                        required
                    },
                    citizenStatus: {
                        required
                    },
                    address: {
                        required
                    },
                    email: {
                        required,
                        email
                    },
                    childCareNeed: {
                        required
                    },
                    childCareOther: {
                        otherNeedValidator
                    }
                },
                coapp: {
                    firstName: {
                        required: requiredIf("coappRequired")
                    },
                    lastName: {
                        required: requiredIf("coappRequired")
                    },
                    email: {
                        required: requiredIf("coappRequired"),
                        email
                    },
                    childCareNeed: {
                        required: requiredIf("coappRequired")
                    },
                    childCareOther: {
                        required: requiredIf("coappOtherRequired")
                    },
                    citizenStatus: {
                        required: requiredIf("coappRequired")
                    },
                    otherNumber: {
                        required: requiredUnless("coappCellPhoneProvided")
                    },
                    cellNumber: {
                        required: requiredUnless("coappOtherPhoneProvided")
                    }
                }
            },
            watch: {
                "applicant.citizenStatus": function(n, o) {
                    this.control.citizenIsError = not(this.applicant.citizenStatus);
                    if (!not(this.applicant.citizenStatus)) {
                        this.sendToServer("applicant.citizenStatus", this.applicant.citizenStatus);
                    }
                },
                "applicant.childCareNeed": function(n, o) {
                    this.control.needIsError = not(this.applicant.childCareNeed);
                    var nstatus = parseInt(this.applicant.childCareNeed);
                    if (nstatus === 2 && !this.applicant.childCareOther.trim()) {
                        this.control.needIsError = true;
                    }
                    if (!not(this.applicant.childCareNeed)) {
                        this.sendToServer("applicant.childCareNeed", this.applicant.childCareNeed);
                    }
                },
                "applicant.maritalStatus": function(n, o) {
                    this.control.maritalIsError = not(this.applicant.maritalStatus);
                    var mstatus = parseInt(this.applicant.maritalStatus);
                    if (mstatus === 1 || mstatus === 2) {
                        this.control.coappIsNeeded = true;
                    }
                    if (!not(this.applicant.maritalStatus)) {
                        this.sendToServer("applicant.maritalStatus", this.applicant.maritalStatus);
                    }
                },
                "coapp.citizenStatus": function(n, o) {
                    if (!not(this.coapp.citizenStatus)) {
                        this.sendToServer("coapp.citizenStatus", this.coapp.citizenStatus);
                    }
                },
                "coapp.childCareNeed": function(n, o) {
                    var nstatus = parseInt(this.coapp.childCareNeed);
                    if (nstatus === 2 && !!this.coapp.childCareNeed) {
                        this.sendToServer("coapp.childCareNeed", this.coapp.childCareNeed);
                    }
                }
            },
            methods: {
                finishedHandler: function(val) {
                    this.control[val] = true;
                },
                editAddress: function() {
                    window.loadAddressModal();
                },
                saveApplicant: function() {
                    vm.$v.$reset();
                    validateAllFields();
                    window.debug("AnyError=" + vm.$v.$anyError);
                    if (!vm.$v.$anyError) {
                        window.debug("saving and continuing..");
                    } else {
                        window.app.info(
                            "Please provide all required information.",
                            "Missing or Invalid Information"
                        );
                    }
                },
                validatePhone: function() {
                    this.control.phoneIsError =
                        not(this.applicant.homeNumber.trim()) &&
                        not(this.applicant.cellNumber.trim());

                    if (!this.control.phoneIsError && !!this.applicant.homeNumber.trim()) {
                        this.control.phoneIsError = !app.validPhoneNumber(
                            this.applicant.homeNumber.trim()
                        );
                        if (this.control.phoneIsError) vm.$v.applicant.homeNumber.$touch();
                        else vm.$v.applicant.homeNumber.$reset();
                    }
                    if (!this.control.phoneIsError && !!this.applicant.cellNumber.trim()) {
                        var err = !app.validPhoneNumber(this.applicant.cellNumber.trim());

                        if (err) vm.$v.applicant.homeNumber.$touch();
                        else vm.$v.applicant.homeNumber.$reset();
                        this.control.phoneIsError = err || this.control.phoneIsError;
                    }
                },
                validateApplicant: function() {
                    // validate name
                    if (not(this.applicant.firstName)) vm.$v.applicant.firstName.$touch();
                    else vm.$v.applicant.firstName.$reset();
                    if (not(this.applicant.lastName)) vm.$v.applicant.lastName.$touch();
                    else vm.$v.applicant.lastName.$reset();

                    // validate address
                    if (not(this.applicant.address)) vm.$v.applicant.address.$touch();
                    else vm.$v.applicant.address.$reset();

                    // validate phone
                    this.validatePhone();
                    //this.control.phoneIsError =
                    //    not(this.applicant.homeNumber) && not(this.applicant.cellNumber);

                    // validate citizen
                    this.control.citizenIsError = not(this.applicant.citizenStatus);

                    // validate need
                    this.control.needIsError = not(this.applicant.childCareNeed);

                    if (
                        parseInt(this.applicant.childCareNeed) === 2 &&
                        !this.applicant.childCareOther
                    ) {
                        this.control.needIsError = true;
                    }

                    // validate marital status
                    this.control.maritalIsError = not(this.applicant.maritalStatus);

                    return (
                        not(this.control.nameIsError) &&
                        not(this.control.addressIsError) &&
                        not(this.control.phoneIsError) &&
                        not(this.control.citizenIsError) &&
                        not(this.control.needIsError) &&
                        not(this.control.maritalIsError)
                    );
                },
                saveCoApplicantName: function() {
                    if (!vm.$v.coapp.firstName.$invalid && !vm.$v.coapp.lastName.$invalid) {
                        if (vm.$v.coapp.firstName.$dirty || vm.$v.coapp.lastName.$dirty) {
                            this.sendToServer(
                                "coapp.fullName",
                                this.coapp.firstName + "|" + this.coapp.lastName,
                                function() {
                                    vm.$v.coapp.firstName.$reset();
                                    vm.$v.coapp.lastName.$reset();
                                }
                            );
                        }
                    }
                },
                saveApplicantName: function() {
                    if (!vm.$v.applicant.firstName.$invalid && !vm.$v.applicant.lastName.$invalid) {
                        if (vm.$v.applicant.firstName.$dirty || vm.$v.applicant.lastName.$dirty) {
                            this.sendToServer(
                                "applicant.fullName",
                                this.applicant.firstName + "|" + this.applicant.lastName,
                                function() {
                                    vm.$v.applicant.firstName.$reset();
                                    vm.$v.applicant.lastName.$reset();
                                }
                            );
                        }
                    }
                },
                saveApplicantHomeNumber: function() {
                    if (!vm.$v.applicant.homeNumber.$invalid) {
                        if (vm.$v.applicant.homeNumber.$dirty) {
                            this.sendToServer(
                                "applicant.homeNumber",
                                this.applicant.homeNumber.trim(),
                                function() {
                                    vm.$v.applicant.homeNumber.$reset();
                                }
                            );
                        }
                    }
                },
                saveApplicantCellNumber: function() {
                    if (!vm.$v.applicant.cellNumber.$invalid) {
                        if (vm.$v.applicant.cellNumber.$dirty) {
                            this.sendToServer(
                                "applicant.cellNumber",
                                this.applicant.cellNumber.trim(),
                                function() {
                                    vm.$v.applicant.cellNumber.$reset();
                                }
                            );
                        }
                    }
                },
                saveApplicantNeedOther: function() {
                    var nstatus = parseInt(this.applicant.childCareNeed);
                    if (
                        nstatus === 2 &&
                        !vm.$v.applicant.childCareOther.$invalid &&
                        vm.$v.applicant.childCareOther.$dirty
                    ) {
                        this.sendToServer(
                            "applicant.childCareOther",
                            this.applicant.childCareOther.trim(),
                            function() {
                                vm.$v.applicant.childCareOther.$reset();
                            }
                        );
                    }
                },
                saveCoApplicantNeedOther: function() {
                    var nstatus = parseInt(this.coapp.childCareNeed);
                    if (
                        nstatus === 2 &&
                        !vm.$v.coapp.childCareOther.$invalid &&
                        vm.$v.coapp.childCareOther.$dirty
                    ) {
                        this.sendToServer(
                            "coapp.childCareOther",
                            this.coapp.childCareOther.trim(),
                            function() {
                                vm.$v.coapp.childCareOther.$reset();
                            }
                        );
                    }
                },
                saveCoApplicantOtherNumber: function() {
                    if (!vm.$v.coapp.otherNumber.$invalid) {
                        if (vm.$v.coapp.otherNumber.$dirty) {
                            this.sendToServer(
                                "coapp.otherNumber",
                                this.coapp.otherNumber.trim(),
                                function() {
                                    vm.$v.coapp.otherNumber.$reset();
                                }
                            );
                        }
                    }
                },
                saveCoApplicantCellNumber: function() {
                    if (!vm.$v.coapp.cellNumber.$invalid) {
                        if (vm.$v.coapp.cellNumber.$dirty) {
                            this.sendToServer(
                                "coapp.cellNumber",
                                this.coapp.cellNumber.trim(),
                                function() {
                                    vm.$v.coapp.cellNumber.$reset();
                                }
                            );
                        }
                    }
                },
                saveCoApplicantEmail: function() {
                    if (!vm.$v.coapp.email.$invalid) {
                        if (vm.$v.coapp.email.$dirty) {
                            this.sendToServer("coapp.email", this.coapp.email.trim(), function() {
                                vm.$v.coapp.email.$reset();
                            });
                        }
                    }
                },
                sendToServer: function(key, data, callback) {
                    window.saveData(this.applicant.id, key, data, callback);
                }
            },
            created: function() {
                //window.debug("created");
                getData();
            },
            mounted: function() {
                //window.debug("mounted");
            },
            updated: function() {
                //window.debug("mounted");
                if (!window.dataIsLoaded) {
                    this.$nextTick(function() {
                        // window.debug("$nextTick");
                        // Code that will run only after the entire view has been re-rendered

                        // ensure the screen has at least one update before saving any data.
                        window.dataIsLoaded = true;
                    });
                }
            }
        });

        $("*[data-val='true']").change(function() {
            $(this).valid();
        });

        // get tab from hash '#!/tab-<one|two|etc>/other values
        // and then set checked state and refresh radio button
        var hash = window.location.hash;
        if (!hash || hash.trim() === "#!") {
            window.location.hash = "#!/tab-one/";
        } else if (hash.indexOf("tab-") >= 0) {
            // load tab

            $(".worko-tabs .state").removeProp("checked");
            var parts = hash.split("/");

            $(".worko-tabs #" + parts[1])
                .prop("checked", true)
                .button("refresh");

            if (parts[1] !== "tab-one") {
                loadTabData(parts[1]);
            }
        }

        //  basic router function, load js for each tab
        $(".worko-tabs .state").on("click", function() {
            switchTabs();
            var id = $(this).prop("id");
            if (id !== "tab-one") {
                loadTabData(id);
            }
        });
    }
});

function loadTabData(id) {
    window.debug("loading tab data for " + id);
    var url = window.app.hrefPrefix() + "/Scripts/ondemand/subsidy-" + id + "-panel.js";
    $.getScript(url, function(data, textStatus, jqxhr) {
        window.debug(textStatus); // Success
        window.debug(jqxhr.status); // 200
        window.debug("Load was performed for " + id);
        tabDataLoaded(id);
    });
}

function tabDataLoaded(id) {
    window.debug("tabDataLoaded id=" + id);
    var data = window.app.tabs[id];

    data.init("#" + id + "-panel", window.appId);
    window.debug(data);
}

function switchTabs() {
    var parts = window.location.hash.split("/");
    var id = $(".worko-tabs .state:checked").prop("id");
    var newHash = "";
    for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf("tab-") >= 0) {
            parts[i] = id;
        }
        if (parts[i]) newHash += parts[i] + "/";
    }

    window.location.hash = newHash;
}
